import { render } from "./ConsentAttachmentsModal.vue?vue&type=template&id=4815b718&scoped=true"
import script from "./ConsentAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./ConsentAttachmentsModal.vue?vue&type=script&lang=js"

import "./ConsentAttachmentsModal.vue?vue&type=style&index=0&id=4815b718&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4815b718"]])

export default __exports__